import {
  AUTH_2FA_EXPIRED,
  AUTH_2FA_FAILED,
  AUTH_2FA_REQUIRED,
  AUTH_2FA_RESEND_FAILED,
  AUTH_2FA_RESEND_SUCCESS,
  AUTH_2FA_RESENDING,
  AUTH_AUTHENTICATING,
  AUTH_CHANGE_PASSWORD_FAILED,
  AUTH_CHANGE_PASSWORD_SUCCESS,
  AUTH_CHANGING_PASSWORD,
  AUTH_ENDIMPERSONATING,
  AUTH_ENDIMPERSONATING_FAILED,
  AUTH_ENDIMPERSONATING_SUCCESS,
  AUTH_FAILED,
  AUTH_IMPERSONATE_FAILED,
  AUTH_IMPERSONATE_SUCCESS,
  AUTH_IMPERSONATING,
  AUTH_LOCKED,
  AUTH_RESET_PASSWORD_FAILED,
  AUTH_RESET_PASSWORD_SUCCESS,
  AUTH_RESETTING_PASSWORD,
  AUTH_SIGNING_OUT,
  AUTH_SIGNING_OUT_FAILED,
  AUTH_SIGNING_OUT_SUCCESS,
  AUTH_SUCCESS,
} from "../actions/auth";

export default function auth(state = {}, action) {
  switch (action.type) {
    case AUTH_AUTHENTICATING:
      return Object.assign({}, state, {
        readyState: AUTH_AUTHENTICATING,
      });
    case AUTH_FAILED:
      return Object.assign({}, state, {
        readyState: AUTH_FAILED,
        attempts: action.error.response.data.attempts || 0,
        error: action.error,
      });
    case AUTH_LOCKED:
      return Object.assign({}, state, {
        readyState: AUTH_LOCKED,
        retryAfterSeconds: action.error.response.data.retry_after_seconds || null,
        error: action.error,
      });
    case AUTH_SUCCESS:
      return Object.assign({}, state, {
        two_factor: undefined,
        readyState: AUTH_SUCCESS,
        auth: action.result,
      });
    case AUTH_SIGNING_OUT:
      return Object.assign({}, state, {
        readyState: AUTH_SIGNING_OUT,
      });
    case AUTH_SIGNING_OUT_SUCCESS:
      return Object.assign({}, state, {
        readyState: AUTH_SIGNING_OUT_SUCCESS,
      });
    case AUTH_SIGNING_OUT_FAILED:
      return Object.assign({}, state, {
        readyState: AUTH_SIGNING_OUT_FAILED,
        error: action.error,
      });
    case AUTH_CHANGING_PASSWORD:
      return Object.assign({}, state, {
        readyState: AUTH_CHANGING_PASSWORD,
      });
    case AUTH_CHANGE_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        readyState: AUTH_CHANGE_PASSWORD_SUCCESS,
        auth: action.result,
      });
    case AUTH_CHANGE_PASSWORD_FAILED:
      return Object.assign({}, state, {
        readyState: AUTH_CHANGE_PASSWORD_FAILED,
        error: action.error,
      });
    case AUTH_RESETTING_PASSWORD:
      return Object.assign({}, state, {
        readyState: AUTH_RESETTING_PASSWORD,
      });
    case AUTH_RESET_PASSWORD_SUCCESS:
      return Object.assign({}, state, {
        readyState: AUTH_RESET_PASSWORD_SUCCESS,
      });
    case AUTH_RESET_PASSWORD_FAILED:
      return Object.assign({}, state, {
        readyState: AUTH_RESET_PASSWORD_FAILED,
        error: action.error,
      });
    case AUTH_IMPERSONATING:
      return Object.assign({}, state, {
        readyState: AUTH_IMPERSONATING,
      });
    case AUTH_IMPERSONATE_SUCCESS:
      return Object.assign({}, state, {
        readyState: AUTH_IMPERSONATE_SUCCESS,
      });
    case AUTH_IMPERSONATE_FAILED:
      return Object.assign({}, state, {
        readyState: AUTH_IMPERSONATE_FAILED,
        error: action.error,
      });
    case AUTH_ENDIMPERSONATING:
      return Object.assign({}, state, {
        readyState: AUTH_ENDIMPERSONATING,
      });
    case AUTH_ENDIMPERSONATING_SUCCESS:
      return Object.assign({}, state, {
        readyState: AUTH_ENDIMPERSONATING_SUCCESS,
      });
    case AUTH_ENDIMPERSONATING_FAILED:
      return Object.assign({}, state, {
        readyState: AUTH_ENDIMPERSONATING_FAILED,
        error: action.error,
      });
    case AUTH_2FA_REQUIRED:
      return Object.assign({}, state, {
        readyState: AUTH_2FA_REQUIRED,
        two_factor: action.result,
      });
    case AUTH_2FA_FAILED:
      return Object.assign({}, state, {
        readyState: AUTH_2FA_FAILED,
      });
    case AUTH_2FA_EXPIRED:
      return Object.assign({}, state, {
        two_factor: undefined,
        readyState: AUTH_2FA_EXPIRED,
      });
    case AUTH_2FA_RESENDING:
      return Object.assign({}, state, {
        readyState: AUTH_2FA_RESENDING,
      });
    case AUTH_2FA_RESEND_SUCCESS:
      return Object.assign({}, state, {
        readyState: AUTH_2FA_REQUIRED,
      });
    case AUTH_2FA_RESEND_FAILED:
      return Object.assign({}, state, {
        readyState: AUTH_2FA_RESEND_FAILED,
      });
    default:
      return state;
  }
}
